import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Analisi preventiva",
    desc: "Comprensione del contesto operativo, mappatura delle aree di rischio e definizione del perimetro dell'intervento. Una valutazione tecnica che orienta scelte e tempistiche.",
  },
  {
    n: "02",
    title: "Struttura contrattuale",
    desc: "Definizione di un'architettura contrattuale chiara, bilanciata ed enforceable. Clausole sostanziali, allocazione del rischio, garanzie e meccanismi di tutela.",
  },
  {
    n: "03",
    title: "Gestione operativa del rischio",
    desc: "Presidio dell'operazione fino al closing e oltre. Supporto in fase esecutiva, gestione di varianti, riserve, contestazioni e contenzioso.",
  },
];

export default function Approach() {
  return (
    <section
      id="approccio"
      className="relative py-28 lg:py-40 bg-[#EAECE7] text-[#0A0A0A]"
      data-testid="approach-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl mb-20"
        >
          <div
            className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#1B3B36] mb-5"
            data-testid="approach-overline"
          >
            Approccio
          </div>
          <h2 className="font-display text-4xl lg:text-6xl font-medium leading-[1.02] tracking-tight">
            Approccio pragmatico
            <span className="block italic font-normal text-[#1B3B36]">
              e orientato alle operazioni.
            </span>
          </h2>
          <p className="mt-8 text-lg lg:text-xl text-[#0A0A0A]/70 max-w-2xl leading-relaxed">
            L&apos;attività professionale è focalizzata sulla prevenzione del
            rischio, sulla strutturazione efficace dei rapporti contrattuali
            e sull&apos;assistenza nelle operazioni societarie e immobiliari più
            rilevanti.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-px bg-[#0A0A0A]/15 border border-[#0A0A0A]/15">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="bg-[#EAECE7] p-10 lg:p-12 group hover:bg-[#F2F3EE] transition-colors"
              data-testid={`approach-step-${s.n}`}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-display text-5xl lg:text-6xl text-[#1B3B36] font-medium">
                  {s.n}
                </span>
                <span className="text-[10px] tracking-[0.22em] uppercase font-semibold text-[#0A0A0A]/40">
                  Step
                </span>
              </div>
              <h3 className="font-display text-2xl lg:text-3xl font-medium tracking-tight leading-tight mb-4">
                {s.title}
              </h3>
              <p className="text-[15px] text-[#0A0A0A]/65 leading-relaxed">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
